import { render } from "./OrderSetting.vue?vue&type=template&id=3f46dc92&scoped=true"
import script from "@/assets/js/order.js?vue&type=script&lang=js&external"
export * from "@/assets/js/order.js?vue&type=script&lang=js&external"

import "@/assets/css/order.css?vue&type=style&index=0&id=3f46dc92&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f46dc92"]])

export default __exports__